import { DuckSelector, objectDuckCreator } from '@atc/modular-redux';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default objectDuckCreator({
    ...srpDuckPreset,
    store: 'footerAd',
    initialState: {
        hideFooterAd: false,
    },
}).extend({
    selectors: () => ({
        getHideFooterAd: new DuckSelector((selectors) => (state) => selectors.getDuckState(state).hideFooterAd),
    }),
});
